<template>
  <el-dialog
    :title="dialogTitle"
    :model-value="dialogVisible"
    width="650px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="formRef" :model="formData" :rules="formRules" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="模块标识" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="请输入模块标识（如 system）"
              :disabled="isUpdate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="模块名称" prop="title">
            <el-input v-model="formData.title" placeholder="请输入模块名称" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="模块版本" prop="version">
            <el-input v-model="formData.version" placeholder="1.0.0" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="模块作者">
            <el-input v-model="formData.author" placeholder="请输入作者" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="模块类型" prop="type">
            <el-select v-model="formData.type" placeholder="请选择模块类型" style="width: 100%">
              <el-option label="系统模块" :value="1" />
              <el-option label="业务模块" :value="2" />
              <el-option label="工具模块" :value="3" />
              <el-option label="插件模块" :value="4" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排序">
            <el-input-number
              v-model="formData.sort"
              :min="0"
              placeholder="排序"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="模块图标">
            <el-input v-model="formData.icon" placeholder="请输入图标名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="启动类名">
            <el-input v-model="formData.mainClass" placeholder="全限定类名" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="是否内置模块" prop="builtIn">
            <el-radio-group v-model="formData.builtIn">
              <el-radio :value="true">是</el-radio>
              <el-radio :value="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="租户隔离" prop="tenantIsolated">
            <el-radio-group v-model="formData.tenantIsolated">
              <el-radio :value="true">启用</el-radio>
              <el-radio :value="false">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="依赖模块">
        <el-input v-model="dependenciesInput" placeholder="JSON数组格式，如 ['system','infra']" />
      </el-form-item>
      <el-form-item label="模块描述">
        <el-input
          v-model="formData.description"
          type="textarea"
          :rows="3"
          placeholder="请输入模块描述"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="formData.remark" type="textarea" :rows="2" placeholder="请输入备注" />
      </el-form-item>

      <el-divider content-position="left">管理后台卡片</el-divider>
      <el-form-item label="显示卡片">
        <el-switch v-model="adminCardVisible" />
      </el-form-item>
      <el-form-item label="核心业务模块">
        <el-switch v-model="adminCardHomeShortcut" />
        <span class="ml-8px text-12px text-[var(--el-text-color-secondary)]">
          开启后进入工作台「核心业务模块」推荐，最多 12 个、每排 4 个
        </span>
      </el-form-item>
      <template v-if="adminCardVisible">
        <el-form-item label="展示区域">
          <el-checkbox-group v-model="adminCardCenters">
            <el-checkbox value="ai-app">AI应用</el-checkbox>
            <el-checkbox value="business">中台</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="入口路由">
              <el-input v-model="adminCardEntryPath" placeholder="例如 /mall" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="首页路由">
              <el-input v-model="adminCardHomePath" placeholder="例如 /mall/overview" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="卡片图标图片">
          <UploadImg
            v-model="adminCardIconUrl"
            directory="system/module-card-icon"
            height="80px"
            width="80px"
          />
          <div class="ml-0 mt-4px text-12px text-[var(--el-text-color-secondary)]">
            优先展示；清空后回落下方字体图标
          </div>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="卡片图标">
              <IconSelect v-model="adminCardIcon" clearable />
              <div class="mt-4px text-12px text-[var(--el-text-color-secondary)]">
                无图片时使用
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡片颜色">
              <el-color-picker v-model="adminCardColor" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="打开方式">
              <el-select v-model="adminCardOpenMode" style="width: 100%">
                <el-option label="当前窗口" value="same-window" />
                <el-option label="新窗口" value="new-window" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="adminCardOpenMode === 'new-window'" label="独立页路由">
              <el-input v-model="adminCardStandalonePath" placeholder="不填则使用首页路由" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <el-divider content-position="left">商家中心</el-divider>
      <el-form-item label="支持商家中心">
        <el-switch v-model="formData.hasMerchantCenter" />
      </el-form-item>
      <template v-if="formData.hasMerchantCenter">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家模块 ID" required>
              <el-input v-model="merchantModuleId" placeholder="例如 MALL" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商家中心标题" required>
              <el-input v-model="merchantModuleTitle" placeholder="例如 商城管理" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="前端注册键" required>
              <el-input v-model="merchantFrontendKey" placeholder="例如 MALL" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商家中心排序" required>
              <el-input-number v-model="merchantModuleSort" :min="0" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="允许开通场景" required>
          <el-checkbox-group v-model="merchantOpenScenes">
            <el-checkbox value="ADMIN_INITIAL">平台首批</el-checkbox>
            <el-checkbox value="ADMIN_APPEND">后台追加</el-checkbox>
            <el-checkbox value="APP_ONBOARDING">移动端入驻</el-checkbox>
            <el-checkbox value="SYSTEM_RETRY">系统补偿</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="要求主账号">
              <el-switch v-model="merchantRequiresAccount" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="允许新增开通">
              <el-switch v-model="merchantOpenEnabled" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <!-- 移动端配置 -->
      <el-divider content-position="left">
        <el-icon><icon-ep:mobile /></el-icon>
        移动端配置
        <el-tag size="small" type="info" style="margin-left: 8px">选填</el-tag>
      </el-divider>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="TabBar 文本" prop="mobileTabBarText">
            <el-input v-model="mobileTabBarText" placeholder="底部导航栏显示文字" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="TabBar 排序">
            <el-input-number
              v-model="mobileTabBarOrder"
              :min="0"
              placeholder="排序"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="TabBar 默认图标">
            <el-input v-model="mobileTabBarIcon" placeholder="图标路径" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="TabBar 选中图标">
            <el-input v-model="mobileTabBarActiveIcon" placeholder="选中时图标路径" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="模块首页路径">
            <el-input v-model="mobileHomePath" placeholder="如 /pages/modules/mall/index" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主题色">
            <el-color-picker v-model="mobileThemeColor" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="启用子功能">
        <el-input-tag
          v-model="mobileFeatures"
          placeholder="输入后按回车添加，如 product,order,cart"
          class="w-full"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button :disabled="formLoading" @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="formLoading" @click="handleSubmit">确定</el-button>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
import * as ModuleApi from '@/api/system/module/index'
import { UploadImg } from '@/components/UploadFile'

defineOptions({ name: 'ModuleForm' })

const emit = defineEmits(['success'])
const dialogVisible = ref(false)
const dialogTitle = ref('')
const formRef = ref()
const formLoading = ref(false)
const isUpdate = ref(false)

const formData = reactive<ModuleApi.ModuleVO>({
  name: '',
  title: '',
  version: '1.0.0',
  author: '',
  type: 2,
  icon: '',
  mainClass: '',
  sort: 0,
  builtIn: false,
  tenantIsolated: true,
  dependencies: '',
  description: '',
  remark: '',
  hasMerchantCenter: false,
  merchantCenterConfig: ''
})

const dependenciesInput = ref('')

const baseModuleConfig = ref<Record<string, any>>({})
const adminCardVisible = ref(false)
const adminCardCenters = ref<ModuleApi.ModuleCardCenter[]>([])
const adminCardEntryPath = ref('')
const adminCardHomePath = ref('')
const adminCardStandalonePath = ref('')
const adminCardOpenMode = ref<'same-window' | 'new-window'>('new-window')
const adminCardIcon = ref('')
const adminCardIconUrl = ref('')
const adminCardColor = ref('#1677FF')
const adminCardHomeShortcut = ref(false)

const merchantModuleId = ref('')
const merchantModuleTitle = ref('')
const merchantModuleSort = ref(0)
const merchantFrontendKey = ref('')
const merchantOpenScenes = ref<ModuleApi.MerchantModuleOpenScene[]>([])
const merchantRequiresAccount = ref(true)
const merchantOpenEnabled = ref(true)

const resetMerchantCenterFields = () => {
  merchantModuleId.value = ''
  merchantModuleTitle.value = ''
  merchantModuleSort.value = 0
  merchantFrontendKey.value = ''
  merchantOpenScenes.value = []
  merchantRequiresAccount.value = true
  merchantOpenEnabled.value = true
}

const parseMerchantCenterConfig = (configStr?: string) => {
  resetMerchantCenterFields()
  if (!configStr) return
  try {
    const config = JSON.parse(configStr) as ModuleApi.MerchantCenterConfig
    merchantModuleId.value = config.moduleId || ''
    merchantModuleTitle.value = config.title || ''
    merchantModuleSort.value = config.sort ?? 0
    merchantFrontendKey.value = config.frontendKey || ''
    merchantOpenScenes.value = Array.isArray(config.openScenes) ? config.openScenes : []
    merchantRequiresAccount.value = config.requiresAccount !== false
    merchantOpenEnabled.value = config.enabled !== false
  } catch {
    // 后端会做最终 JSON 校验；无法解析的历史配置按空表单展示。
  }
}

const buildMerchantCenterConfig = (): string =>
  JSON.stringify({
    moduleId: merchantModuleId.value.trim().toUpperCase(),
    title: merchantModuleTitle.value.trim(),
    sort: merchantModuleSort.value,
    frontendKey: merchantFrontendKey.value.trim().toUpperCase(),
    openScenes: merchantOpenScenes.value,
    requiresAccount: merchantRequiresAccount.value,
    enabled: merchantOpenEnabled.value
  } satisfies ModuleApi.MerchantCenterConfig)

const resetAdminCardFields = () => {
  baseModuleConfig.value = {}
  adminCardVisible.value = false
  adminCardCenters.value = []
  adminCardEntryPath.value = ''
  adminCardHomePath.value = ''
  adminCardStandalonePath.value = ''
  // 与运行时 moduleCard.buildModuleCards 语义一致：缺失 openMode 默认新窗口，
  // 否则编辑保存会把缺失值固化为 same-window，导致 AI智慧餐饮等卡片反复失去新窗口打开
  adminCardOpenMode.value = 'new-window'
  adminCardIcon.value = ''
  adminCardIconUrl.value = ''
  adminCardColor.value = '#1677FF'
  adminCardHomeShortcut.value = false
}

const parseAdminCardConfig = (configStr?: string) => {
  resetAdminCardFields()
  if (!configStr) return
  try {
    const config = JSON.parse(configStr)
    baseModuleConfig.value = config && typeof config === 'object' ? config : {}
    const card = baseModuleConfig.value.adminCard || {}
    adminCardVisible.value = card.visible === true
    adminCardCenters.value = Array.isArray(card.centers) ? card.centers : []
    adminCardEntryPath.value = card.entryPath || ''
    adminCardHomePath.value = card.homePath || ''
    adminCardStandalonePath.value = card.standalonePath || ''
    // 与 buildModuleCards 对齐：仅明确 same-window 才同窗，缺失/未知值一律按新窗口回显，
    // 避免无 openMode 的历史配置被编辑保存后固化成 same-window
    adminCardOpenMode.value = card.openMode === 'same-window' ? 'same-window' : 'new-window'
    adminCardIcon.value = card.icon || ''
    adminCardIconUrl.value = card.iconUrl || ''
    adminCardColor.value = card.color || '#1677FF'
    adminCardHomeShortcut.value = card.homeShortcut === true
  } catch {
    baseModuleConfig.value = {}
  }
}

const buildAdminCardConfig = () => {
  const config = { ...baseModuleConfig.value }
  config.adminCard = {
    visible: adminCardVisible.value,
    centers: adminCardCenters.value,
    entryPath: adminCardEntryPath.value,
    homePath: adminCardHomePath.value,
    standalonePath: adminCardStandalonePath.value,
    openMode: adminCardOpenMode.value,
    icon: adminCardIcon.value,
    iconUrl: adminCardIconUrl.value,
    color: adminCardColor.value,
    homeShortcut: adminCardHomeShortcut.value
  }
  return JSON.stringify(config)
}

// 移动端配置字段
const mobileTabBarText = ref('')
const mobileTabBarOrder = ref(0)
const mobileTabBarIcon = ref('')
const mobileTabBarActiveIcon = ref('')
const mobileHomePath = ref('')
const mobileThemeColor = ref('#1677FF')
const mobileFeatures = ref<string[]>([])

/** 解析 mobileConfig JSON 到表单字段 */
const parseMobileConfig = (configStr?: string) => {
  resetMobileFields()
  if (!configStr) return
  try {
    const config = JSON.parse(configStr)
    if (config.tabBar) {
      mobileTabBarText.value = config.tabBar.text || ''
      mobileTabBarOrder.value = config.tabBar.order ?? 0
      mobileTabBarIcon.value = config.tabBar.iconPath || ''
      mobileTabBarActiveIcon.value = config.tabBar.selectedIconPath || ''
    }
    mobileHomePath.value = config.homePath || ''
    mobileFeatures.value = config.features || []
    if (config.theme) {
      mobileThemeColor.value = config.theme.primaryColor || '#1677FF'
    }
  } catch {
    // 按空处理
  }
}

/** 将表单字段序列化回 mobileConfig JSON */
const buildMobileConfig = (): string => {
  const config: any = {}
  if (mobileTabBarText.value || mobileTabBarIcon.value) {
    config.tabBar = {
      text: mobileTabBarText.value,
      order: mobileTabBarOrder.value,
      iconPath: mobileTabBarIcon.value,
      selectedIconPath: mobileTabBarActiveIcon.value
    }
  }
  if (mobileHomePath.value) {
    config.homePath = mobileHomePath.value
  }
  if (mobileFeatures.value.length > 0) {
    config.features = mobileFeatures.value
  }
  if (mobileThemeColor.value && mobileThemeColor.value !== '#1677FF') {
    config.theme = { primaryColor: mobileThemeColor.value }
  }
  // 如果所有字段都为空，返回空字符串
  if (Object.keys(config).length === 0) return ''
  return JSON.stringify(config)
}

/** 重置移动端字段 */
const resetMobileFields = () => {
  mobileTabBarText.value = ''
  mobileTabBarOrder.value = 0
  mobileTabBarIcon.value = ''
  mobileTabBarActiveIcon.value = ''
  mobileHomePath.value = ''
  mobileThemeColor.value = '#1677FF'
  mobileFeatures.value = []
}

const formRules = {
  name: [{ required: true, message: '模块标识不能为空', trigger: 'blur' }],
  title: [{ required: true, message: '模块名称不能为空', trigger: 'blur' }],
  version: [{ required: true, message: '模块版本不能为空', trigger: 'blur' }],
  type: [{ required: true, message: '模块类型不能为空', trigger: 'change' }]
}

/** 打开弹窗 */
const open = async (type: string, id?: number) => {
  resetForm()
  if (type === 'create') {
    dialogTitle.value = '新增模块'
    isUpdate.value = false
  } else if (type === 'update' && id) {
    dialogTitle.value = '修改模块'
    isUpdate.value = true
    await loadDetail(id)
  }
  dialogVisible.value = true
}

/** 加载详情 */
const loadDetail = async (id: number) => {
  try {
    const data = await ModuleApi.getModule(id)
    Object.assign(formData, data)
    // 格式化依赖
    if (data.dependencies) {
      dependenciesInput.value = data.dependencies
    }
    // 解析移动端配置
    parseMobileConfig(data.mobileConfig)
    parseAdminCardConfig(data.config)
    parseMerchantCenterConfig(data.merchantCenterConfig)
  } catch {
    // 加载失败
  }
}

/** 重置表单 */
const resetForm = () => {
  formRef.value?.resetFields()
  formData.name = ''
  formData.title = ''
  formData.version = '1.0.0'
  formData.author = ''
  formData.type = 2
  formData.icon = ''
  formData.mainClass = ''
  formData.sort = 0
  formData.builtIn = false
  formData.tenantIsolated = true
  formData.dependencies = ''
  formData.description = ''
  formData.remark = ''
  formData.config = ''
  formData.hasMerchantCenter = false
  formData.merchantCenterConfig = ''
  dependenciesInput.value = ''
  resetAdminCardFields()
  resetMobileFields()
  resetMerchantCenterFields()
}

/** 提交 */
const handleSubmit = async () => {
  try {
    await formRef.value?.validate()
  } catch {
    return
  }

  formLoading.value = true
  try {
    // 处理依赖输入
    if (dependenciesInput.value) {
      try {
        JSON.parse(dependenciesInput.value)
        formData.dependencies = dependenciesInput.value
      } catch {
        ElMessage.warning('依赖模块格式错误，请输入有效的JSON数组')
        formLoading.value = false
        return
      }
    } else {
      formData.dependencies = '[]'
    }

    // 构建移动端配置
    formData.mobileConfig = buildMobileConfig()
    formData.config = buildAdminCardConfig()
    if (formData.hasMerchantCenter) {
      if (
        !merchantModuleId.value.trim() ||
        !merchantModuleTitle.value.trim() ||
        !merchantFrontendKey.value.trim() ||
        merchantOpenScenes.value.length === 0
      ) {
        ElMessage.warning('请完整填写商家中心配置和允许开通场景')
        return
      }
      const codePattern = /^[A-Z][A-Z0-9_]*$/
      if (
        !codePattern.test(merchantModuleId.value.trim().toUpperCase()) ||
        !codePattern.test(merchantFrontendKey.value.trim().toUpperCase())
      ) {
        ElMessage.warning('商家模块 ID 和前端注册键只能包含大写字母、数字和下划线')
        return
      }
      formData.merchantCenterConfig = buildMerchantCenterConfig()
    } else {
      formData.merchantCenterConfig = ''
    }

    if (isUpdate.value) {
      await ModuleApi.updateModule(formData)
      ElMessage.success('修改成功')
    } else {
      await ModuleApi.createModule(formData)
      ElMessage.success('新增成功')
    }
    handleClose()
    emit('success')
  } finally {
    formLoading.value = false
  }
}

/** 关闭弹窗 */
const handleClose = () => {
  dialogVisible.value = false
  resetForm()
}

defineExpose({ open })
</script>
